<template>
  <v-dialog width="350px" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn depressed text v-on="on">Update Fee</v-btn>
    </template>
    <v-card>
      <v-card-title>
        Update Application Fee
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="isValid">
          <v-text-field
            label="Amount"
            type="number"
            v-model="amount"
            :rules="rules"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Close</v-btn>
        <v-btn text color="green" @click="submit()">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { db } from "../assets/js/firebase";
export default {
  data() {
    return {
      dialog: false,
      isValid: false,
      amount: 0,
      rules: [
        (v) => !!v || "Field is required",
        (v) => (!!v && v > 0) || "Amount must be greater than 0",
      ],
    };
  },
  methods: {
    listenFee() {
      const vm = this;
      db.child("charge").on("value", (snap) => {
        vm.amount = snap.val();
        console.log("amount updated", vm.amount);
      });
    },
    async submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      vm.$root.loader = true;
      try {
        await db.child("charge").set(vm.amount);
        vm.$root.loader = false;
        vm.dialog = false;
      } catch (error) {
        vm.$root.loader = false;
        vm.$root.alert(error.message);
      }
    },
  },
  beforeDestroy() {
    db.child("charge").off();
  },
  mounted() {
    this.listenFee();
  },
};
</script>

<style></style>
